import { useState } from 'react';

// ─── Replace these 3 values with your EmailJS credentials ───
const EMAILJS_SERVICE_ID  = 'service_pwasx5h';
const EMAILJS_TEMPLATE_ID = 'template_zt9qr7p';
const EMAILJS_PUBLIC_KEY  = '0WEUQoXIt0nn7xEjs';
// ────────────────────────────────────────────────────────────

type Status = 'idle' | 'sending' | 'success' | 'error';

export function Contact() {
  const [form, setForm] = useState({
    from_name: '',
    from_email: '',
    phone: '',
    message: '',
  });
  const [status, setStatus] = useState<Status>('idle');

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');

    try {
      // Dynamically import emailjs so it's only loaded when needed
      const emailjs = await import('@emailjs/browser');

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name:  form.from_name,
          from_email: form.from_email,
          phone:      form.phone,
          message:    form.message,
          to_name:    'Prabhu Mallya & Associates',
        },
        EMAILJS_PUBLIC_KEY
      );

      setStatus('success');
      setForm({ from_name: '', from_email: '', phone: '', message: '' });
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus('error');
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__inner">
        <div className="contact__left">
          <p className="section-eyebrow">Get In Touch</p>
          <h2 className="section-title">Let's talk about<br /><em>your finances</em></h2>
          <div className="contact__info">
            <div className="contact__info-item">
              <span className="contact__info-label">Mangaluru Office</span>
              <span>2nd Floor, A Wing, Rambhavan Complex,<br />Kodailbail, Mangaluru – 575 003</span>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-label">Bengaluru Office</span>
              <span>#32/2, 2nd Floor, 18th Cross,<br />Sadashivanagar, Bengaluru – 560 080</span>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-label">Phone</span>
              <a href="tel:+919886185459">+91-9886185459, +91-87222850877</a>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-label">Email</span>
              <a href="mailto:team@caprabhumallya.com">team@caprabhumallya.com</a>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-label">Hours</span>
              <span>Mon – Sat: 9:30am – 6:00pm</span>
            </div>
          </div>
        </div>

        <div className="contact__right">
          {status === 'success' ? (
            <div className="contact__success">
              <span className="contact__success-icon">✦</span>
              <h3>Message received!</h3>
              <p>Thank you for reaching out. We'll get back to you within one business day.</p>
              <button
                className="btn btn--ghost"
                style={{ marginTop: '1.5rem' }}
                onClick={() => setStatus('idle')}
              >
                Send another message
              </button>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="from_name">Full Name</label>
                  <input
                    id="from_name"
                    name="from_name"
                    type="text"
                    placeholder="Your name"
                    required
                    value={form.from_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="from_email">Email</label>
                  <input
                    id="from_email"
                    name="from_email"
                    type="email"
                    placeholder="your@email.com"
                    required
                    value={form.from_email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="+91 00000 00000"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">How can we help?</label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  placeholder="Tell us about your needs..."
                  required
                  value={form.message}
                  onChange={handleChange}
                />
              </div>

              {status === 'error' && (
                <p className="contact__error">
                  Something went wrong. Please try again or email us directly.
                </p>
              )}

              <button
                type="submit"
                className="btn btn--primary btn--full"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Sending…' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
